import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import './add-leave.css'; // Import your CSS file

const App = () => {
    // State to hold form values
    const [leaveType, setLeaveType] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [reason, setReason] = useState('');

    // State to hold error messages
    const [errors, setErrors] = useState({
        startDate: '',
        endDate: ''
    });

    const navigate = useNavigate(); // Initialize useNavigate hook

    const handleSubmit = (e) => {
        e.preventDefault();
        // Validate form inputs
        let formErrors = {};
        if (!startDate) formErrors.startDate = 'Start date is required.';
        if (!endDate) formErrors.endDate = 'End date is required.';

        // Set errors if there are any
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return;
        }

        // Process form data
        // You can send the form data to the server here
        console.log({
            leaveType,
            startDate,
            endDate,
            reason
        });

        // Clear the form after submission if needed
        setLeaveType('');
        setStartDate('');
        setEndDate('');
        setReason('');
        setErrors({});

        // Navigate to the Pending Leave page
        navigate('./pending-leave');
    };

    return (
        <div className="add-leave-container">
            <section>
                <div className="main-box-upper">
                    <h1 className="title">Apply Leave</h1>
                    <hr />
                </div>
            </section>
            <form className="form-container" onSubmit={handleSubmit}>
                <div className="form-box">
                    <div className="form-row">
                        <div className="form-column">
                            <div className="form-group">
                                <label htmlFor="leave_type">
                                    Leave type <span className="required">*</span> :
                                </label>
                                <select
                                    id="leave_type"
                                    className="form-control"
                                    required
                                    name="leave_type"
                                    value={leaveType}
                                    onChange={(e) => setLeaveType(e.target.value)}
                                >
                                    <option value="">--Select--</option>
                                    <option value="1">Simple Leave</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="leave_start_date">
                                    Start date <span className="required">*</span> :
                                </label>
                                <input
                                    type="date"
                                    id="leave_start_date"
                                    name="leave_start_date"
                                    className="form-control"
                                    required
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                                {errors.startDate && <span className="error-msg">{errors.startDate}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="leave_end_date">
                                    End date <span className="required">*</span> :
                                </label>
                                <input
                                    type="date"
                                    id="leave_end_date"
                                    name="leave_end_date"
                                    className="form-control"
                                    required
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                                {errors.endDate && <span className="error-msg">{errors.endDate}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="leave_reason">
                                    Reason <span className="required">*</span> :
                                </label>
                                <textarea
                                    id="leave_reason"
                                    className="form-control form-control-reason"
                                    required
                                    name="leave_reason"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-actions">
                    <button className="btn btn-primary" type="submit">
                        <i className="fa fa-plus"></i> Apply leave
                    </button>
                </div>
            </form>
        </div>
    );
};

export default App;
